module.exports = __webpack_public_path__ + "media/assets/images/blog/polly_block_1-2e41d7d41bbc537ca551162149dc9449.png";